import { Box } from '@mui/material'
import React, { useState } from 'react'
import Navbar from '../Header/Navbar'
import SideBar from '../Sidebar/SideBar'
import { Outlet } from 'react-router-dom'
import Stransition from '../Sidebar/Stransition'

function Layout() {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Navbar handleMenu={() => setOpen(!open)} />
            <Box sx={{ width: '100%', height: 'calc(100% - 64px)', display: 'flex', flexDirection: 'row' }}>
                <Stransition isOpen={open}>
                    <SideBar />
                </Stransition>
                <Box sx={{ flex: 1 }}>
                    <Outlet />
                </Box>
            </Box>
        </>
    )
}

export default Layout